import styled from 'styled-components';

export default styled.p`
  color: ${props => props.theme.secondary};
  width: 280px;
  margin: ${({ topMargin = 50 }) => topMargin}px auto 0;
  font-size: 14px;
  text-align: center;
  white-space: pre-line;
`;
